export default "__VITE_ASSET__CnNuWtwG__"